"use strict";

var _interopRequireDefault = require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _captcha = require("@/api/captcha");
var _pos = require("@/api/pos");
var _vuex = require("vuex");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _default = {
  name: 'LoginFrom',
  components: {},
  data: function data() {
    return {
      backgroundImage: '#ffffff',
      tabIndex: 'login',
      loginForm: {
        title: '',
        inviter: '',
        mobile: '',
        account: '',
        password: '',
        name: ''
      },
      captcha: {
        image: '',
        code: '',
        uniqid: ''
      },
      btnText: '获取短信验证码',
      btnLoading: false,
      btnDisabled: false,
      passwordType: 'password',
      forgotPassword: false,
      redirect: undefined,
      otherQuery: {},
      config: {},
      loginRules: {
        account: [{
          required: true,
          message: '请输入账号'
        }],
        password: [{
          required: true,
          message: '请输入密码'
        }]
      },
      reRules: {
        name: [{
          required: true,
          message: '请输入姓名'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号'
        }]
      }
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    var query = this.$route.query;
    if (query.inviter_id) {
      this.inviter_id = query.inviter_id;
    }
    this.handleCaptcha();
  },
  mounted: function mounted() {
    if (this.loginForm.account === '') {
      this.$refs.account.focus();
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)({
    login: 'user/login',
    register: 'user/register',
    getState: 'user/getState'
  })), {}, {
    showPwd: function showPwd() {
      var _this = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    handleCaptcha: function handleCaptcha() {
      var _this2 = this;
      (0, _captcha.getImage)().then(function (res) {
        _this2.captcha = res.data;
      });
    },
    handleCode: function handleCode() {
      var _this3 = this;
      if (this.btnDisabled) {
        return false;
      }
      var mobile = this.loginForm.mobile;
      this.btnDisabled = true;
      (0, _captcha.getCode)({
        mobile: mobile
      }).then(function (res) {
        if (!res.code) {
          var time = 60;
          var inter = setInterval(function () {
            _this3.btnText = '重新获取(' + time + ')';
            time--;
            if (time === 0) {
              _this3.btnText = '获取短信验证码';
              _this3.btnDisabled = false;
              clearInterval(inter);
            }
          }, 1000);
        }
      }).catch(function () {
        _this3.btnDisabled = false;
      });
    },
    // 登录
    handleLogin: function handleLogin() {
      var _this4 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this4.btnLoading = true;
          Object.assign(_this4.loginForm, _this4.captcha);
          _this4.login(_this4.loginForm).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var res, _yield$getOwner, data;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this4.getState();
                case 2:
                  res = _context.sent;
                  if (!res.info.pos_id) {
                    _context.next = 7;
                    break;
                  }
                  window.location.reload();
                  _context.next = 17;
                  break;
                case 7:
                  _context.next = 9;
                  return (0, _pos.getOwner)();
                case 9:
                  _yield$getOwner = _context.sent;
                  data = _yield$getOwner.data;
                  if (!(!data || !data.length)) {
                    _context.next = 16;
                    break;
                  }
                  _this4.$router.push({
                    path: '/register'
                  });
                  return _context.abrupt("return", false);
                case 16:
                  (0, _pos.login)({
                    id: data[0].id
                  }).then(function (res) {
                    if (!res.code) {
                      window.location.reload();
                      _this4.$message.success('登录成功');
                    } else {
                      _this4.$message.errpor(res.msg);
                    }
                  });
                case 17:
                  _this4.btnLoading = false;
                case 18:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))).catch(function (error) {
            _this4.$message.error(error);
            _this4.btnLoading = false;
            _this4.handleCaptcha();
          });
        } else {
          console.log('请输入正确的账号和密码');
          return false;
        }
      });
    },
    // 手机登录
    handleMobile: function handleMobile() {
      var _this5 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this5.btnLoading = true;
          Object.assign(_this5.loginForm, _this5.captcha);
          if (_this5.inviter_id) {
            _this5.loginForm.inviter_id = _this5.inviter_id;
          }
          _this5.register(_this5.loginForm).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var res, _yield$getOwner2, data;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this5.getState();
                case 2:
                  res = _context2.sent;
                  if (!res.info.pos_id) {
                    _context2.next = 7;
                    break;
                  }
                  window.location.reload();
                  _context2.next = 17;
                  break;
                case 7:
                  _context2.next = 9;
                  return (0, _pos.getOwner)();
                case 9:
                  _yield$getOwner2 = _context2.sent;
                  data = _yield$getOwner2.data;
                  if (!(!data || !data.length)) {
                    _context2.next = 16;
                    break;
                  }
                  _this5.$router.push({
                    path: '/register'
                  });
                  return _context2.abrupt("return", false);
                case 16:
                  (0, _pos.login)({
                    id: data[0].id
                  }).then(function (res) {
                    if (!res.code) {
                      window.location.reload();
                      _this5.$message.success('登录成功');
                    } else {
                      _this5.$message.errpor(res.msg);
                    }
                  });
                case 17:
                  _this5.btnLoading = false;
                case 18:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))).catch(function (error) {
            _this5.$message.error(error);
            _this5.btnLoading = false;
            _this5.handleCaptcha();
          });
        } else {
          console.log('请输入正确的账号和密码');
          return false;
        }
      });
    },
    // 注册登录
    handleRegister: function handleRegister() {
      var _this6 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this6.btnLoading = true;
          Object.assign(_this6.loginForm, _this6.captcha);
          delete _this6.loginForm.account;
          delete _this6.loginForm.password;
          if (_this6.inviter_id) {
            _this6.loginForm.inviter_id = _this6.inviter_id;
          }
          _this6.register(_this6.loginForm).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var res, _yield$getOwner3, data;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this6.getState();
                case 2:
                  res = _context3.sent;
                  if (!res.info.pos_id) {
                    _context3.next = 7;
                    break;
                  }
                  window.location.reload();
                  _context3.next = 17;
                  break;
                case 7:
                  _context3.next = 9;
                  return (0, _pos.getOwner)();
                case 9:
                  _yield$getOwner3 = _context3.sent;
                  data = _yield$getOwner3.data;
                  if (!(!data || !data.length)) {
                    _context3.next = 16;
                    break;
                  }
                  _this6.$router.push({
                    path: '/register'
                  });
                  return _context3.abrupt("return", false);
                case 16:
                  (0, _pos.login)({
                    id: data[0].id
                  }).then(function (res) {
                    if (!res.code) {
                      window.location.reload();
                      _this6.$message.success('登录成功');
                    } else {
                      _this6.$message.errpor(res.msg);
                    }
                  });
                case 17:
                  _this6.btnLoading = false;
                case 18:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }))).catch(function (error) {
            _this6.$message.error(error);
            _this6.btnLoading = false;
            _this6.handleCaptcha();
          });
        } else {
          return false;
        }
      });
    },
    // 找回密码
    handlePassword: function handlePassword() {
      this.forgotPassword = !this.forgotPassword;
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
  })
};
exports.default = _default;